import { render, staticRenderFns } from "./StudentDocuments.vue?vue&type=template&id=680b7516&scoped=true"
import script from "./StudentDocuments.vue?vue&type=script&lang=js"
export * from "./StudentDocuments.vue?vue&type=script&lang=js"
import style0 from "./StudentDocuments.vue?vue&type=style&index=0&id=680b7516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680b7516",
  null
  
)

export default component.exports